"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoPlayerProps = getVideoPlayerProps;
exports.default = lazyGetPlayerProps;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

// import checkObjectAccess from 'access-control/check-object-access';
var Holder = function Holder() {
  babelHelpers.classCallCheck(this, Holder);
  this.props = null;
  this.lazyProps = null;
};

function getVideoPlayerProps() {
  return Holder.getVideoPlayerProps.apply(Holder, arguments);
}

function lazyGetPlayerProps() {
  return Holder.lazyGetPlayerProps.apply(Holder, arguments);
}